import api from './api';

/**
 * Notifications Service (Admin)
 * Handles admin notifications API calls
 */
const notificationsService = {
    /**
     * Get all notifications
     * @param {Object} params - Query parameters (page, limit, isRead, type, userId)
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/notifications${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Send notification to user(s)
     * @param {Object} data - Notification data
     * @param {string} data.userId - Single user ID (optional)
     * @param {Array<string>} data.userIds - Array of user IDs (optional)
     * @param {boolean} data.sendToAll - Send to all users (optional)
     * @param {string} data.type - Notification type
     * @param {string} data.titleAr - Arabic title
     * @param {string} data.titleEn - English title
     * @param {string} data.bodyAr - Arabic body (optional)
     * @param {string} data.bodyEn - English body (optional)
     * @param {Object} data.data - Additional data (optional)
     * @returns {Promise<Object>}
     */
    sendNotification: async (data) => {
        return api.post('/admin/notifications', data);
    },

    /**
     * Delete a notification
     * @param {string} id - Notification ID
     * @returns {Promise<Object>}
     */
    deleteNotification: async (id) => {
        return api.delete(`/admin/notifications/${id}`);
    },

    /**
     * Delete all notifications
     * @param {Object} params - Query parameters (userId, olderThan)
     * @returns {Promise<Object>}
     */
    deleteAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.delete(`/admin/notifications${queryString ? `?${queryString}` : ''}`);
    }
};

export default notificationsService;
